import { DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { APP_ID, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './modules/home/home.module';
import { InstitutionalModule } from './modules/institutional/institutional.module';
import { NotFoundModule } from './modules/not-found/not-found.module';
import { ComponentsModule } from './shared/components/components.module';
import { DirectiveModule } from './shared/directives/directive.module';
import { PipesModule } from './shared/pipes/pipes.module';
import { GlobalHttpInterceptorService } from './utils/interceptors/http.interceptors';

registerLocaleData(localeEs);

@NgModule({ declarations: [AppComponent],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule, AppRoutingModule, ComponentsModule, HomeModule, NotFoundModule, InstitutionalModule, FormsModule, ReactiveFormsModule, NgxMaskModule.forRoot(), DirectiveModule, PipesModule, BrowserAnimationsModule], providers: [
        provideClientHydration(),
        { provide: APP_ID, useValue: 'serverApp' },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
        {
            provide: LOCALE_ID,
            useValue: 'es-CO',
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
